import React, { useEffect, useState } from "react";
import { Hidden, Row, Col } from "react-grid-system";
import db from '../../Utils/firebase';
import emailjs from '@emailjs/browser';
import Fade from 'react-reveal/Fade';
import { toast } from 'react-toastify';
import SectionTitle from "../../components/common/SectionTitle";

const Contact = () => {
    const [contectinfo, setContactInfo] = useState([]);
    const [username, setUserName] = useState('');
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');

    useEffect(() => {
        FetchContactContentData()
    }, [])

    const handleSubmit = async (e) => {
        e.preventDefault();
        console.log(e.target.email.value);

        const templateParams = {
            user_email: e.target.email.value,
            from_email: e.target.email.value,
            username: e.target.username.value,
            reply_to: e.target.email.value,
            message: e.target.message.value
        };
        

        emailjs.send('service_6iqyifq', 'template_hnel6uk', templateParams , 'ROs_Pcq3iWXb6LLre')
            .then((response) => {
                toast.success('Message Successfully Sent!')
                setUserName('');
                setEmail('');
                setMessage('');
                console.log('SUCCESS!', response.status, response.text);
            }, (err) => {
                toast.error('Something went wrong. Please try again later.')
                console.log('FAILED...', err);
            });

        if (e.target.email.value !== "" && e.target.message.value !== "" && e.target.username.value !== "") {
            await db.collection('root_collection').doc('some_document').collection('ContactList').add({
                name: e.target.username.value,
                email: e.target.email.value,
                message: e.target.message.value,
                createdAt: new Date()
            })
                .then(function () {
                    console.log("Document successfully written!");
                })
                .catch(function (error) {
                    console.error("Error writing document: ", error);
                });
        }

    }

    

    const FetchContactContentData = async () => {

        await db.collection('root_collection').doc('some_document').collection('ContactContent').get()
            .then(querySnapshot => {
                // let arr = [];
                querySnapshot.docs.forEach(doc => {
                    // setlist(doc.data().title);
                    setContactInfo(doc.data());
                });

            });
    }
    return (
        <section className="section section-contact section-contact-1">
             {contectinfo?.title &&
            <div className="display-spacing">
                {/* <Container> */}
                        <Row>
                            <Col lg={5}>
                                <Hidden xs sm md>
                                    <Fade left>
                                    
                                        <div className="contact-image">
                                            {/* <div className="image overlay-image" style={{ backgroundImage: `url('/assets/images/contact/contact.png')` }}></div> */}
                                            <img src="/assets/images/contact/contact.webp" className="contactimag" alt="contact"/>
                                        </div>
                                    </Fade>
                                </Hidden>
                                <Fade bottom>
                                <div className="contact-details-mobile-wrap" style={{ marginBottom: window.innerWidth < 992 ? '60px' : '0' }}>
                                <Row className="contact-detailscls ">
                                    <Col md={6} sm={12} lg={6}>
                                        <h4 className="gradient-text">Phone</h4>
                                        {/* <a target="_blank" rel="noopener noreferrer" href="tel:+919327708369" > */}
                                            <div className="detail">
                                                <i class="fa fa-phone"></i>
                                                <p>+91 9327708369</p>
                                            </div>
                                        {/* </a> */}
                                    </Col>
                                    <Col md={6} sm={12} lg={6}>
                                        <h4 className="gradient-text">Whatsapp</h4>
                                        <a target="_blank" rel="noopener noreferrer" href="https://wa.me/919327708369?text=Hi" >
                                            <div className="detail">
                                                <i class="fa fa-whatsapp"></i>
                                                <p>+91 9327708369</p>
                                            </div>
                                        </a>
                                    </Col>
                                    <Col md={6} sm={12} lg={6}>
                                        <h4 className="gradient-text">Google Chat</h4>
                                        <a target="_blank" rel="noopener noreferrer" href="https://chat.google.com/" >
                                            <div className="detail">
                                                <p>gopihkachhadiya</p>
                                            </div>
                                        </a>    
                                    </Col>
                                    <Col md={6} sm={12} lg={6}>
                                        <h4 className="gradient-text">Email</h4>
                                        <a href="https://mail.google.com/mail/?view=cm&fs=1&tf=1&to=gopihkachhadiya@gmail.com" target="_blank" rel="noopener noreferrer">
                                            <div className="detail">
                                                <i class="fa fa fa-envelope-o"></i>
                                                <p>gopihkachhadiya@gmail.com</p>
                                            </div>
                                        </a>    
                                    </Col>
                                </Row>
                                </div>
                                </Fade>
                            </Col>
                        <Col lg={7}>
                        <Fade right>
                            <div className="contact-content">
                                <SectionTitle label="Contact me" title={contectinfo?.title} align="left" />
                                <form className="form form-1 pt-15" onSubmit={e => { handleSubmit(e) }}>
                                    <Row className="row">
                                        <Col xs={12} sm={12} md={6}>
                                            <div className="form-item">
                                                <input type="text" id="form-item-name"
                                                    name="username"
                                                    value={username}
                                                    onChange={e => setUserName(e.target.value)} />
                                                <label htmlFor="form-item-name">Your Name</label>
                                            </div>
                                        </Col>
                                        <Col xs={12} sm={12} md={6}>
                                            <div className="form-item">
                                                <input type="email" id="form-item-email" name="email" value={email}
                                                    onChange={e => setEmail(e.target.value)} />
                                                <label htmlFor="form-item-email">Your Email</label>
                                            </div>
                                        </Col>
                                        <Col xs={12} sm={12} md={12}>
                                            <div className="form-item">
                                                <textarea id="form-item-message"
                                                    name="message"
                                                    value={message}
                                                    onChange={e => setMessage(e.target.value)}
                                                ></textarea>
                                                <label htmlFor="form-item-message">Your Message</label>
                                            </div>
                                        </Col>
                                        <Col xs={12} sm={12} md={12}>
                                             <button className={`${!username || !email || !message ? 'submit-button' : 'button-primary'} button button-md`} type="submit">
                                                Send Message
                                            </button>
                                        </Col>
                                    </Row>
                                </form>
                            </div>
                            </Fade>

                        </Col>
                    </Row>
                    
                {/* </Container> */}
            </div>
             }
        </section>
        
    );
}

export default Contact;
